import React from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Icon } from '@els/els-react--icon';
import { open as openStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';
import { useDispatch } from 'react-redux';
import parseV3000SumFormula from '@Utils/React/MolFiletoFormula';

import './QuickSearchQuery.scss';

function Query(props) {
  const dispatch = useDispatch();
  const { querylet } = props;
  return (
    <div className={querylet.structure ? `query-let query-let--structure` : `query-let`}>
      {querylet.structures &&
        querylet.structures?.length > 0 &&
        querylet.structures?.map((structure) => (
          <Icon
            id={`structure${uuid()}`}
            key={`structure${uuid()}`}
            sprite="Structure"
            color="secondary"
            className="qb-history-node-structure-icon"
            style={{ cursor: 'pointer' }}
            a11y={{ name: 'Structure Icon', description: 'Structure Icon' }}
            onClick={() =>
              dispatch(
                openStructureDialog(uuid(), structure, {
                  name: parseV3000SumFormula(structure),
                  isLinearFormula: true,
                })
              )
            }
          />
        ))}

      {querylet && querylet.query && querylet.structures ? <span>AND</span> : null}

      <p className="query-let--text">{querylet.description ? querylet.description : ''}</p>
    </div>
  );
}
Query.propTypes = {
  querylet: PropTypes.object,
};
export default withRouter(Query);
